namespace GeniuzPOS.CustomReport {
    export namespace ReportCusPromotionSaleService {
        export const baseUrl = 'CustomReport/ReportCusPromotionSale';

        export declare function Create(request: Serenity.SaveRequest<ReportCusPromotionSaleRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportCusPromotionSaleRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportCusPromotionSaleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportCusPromotionSaleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomReport/ReportCusPromotionSale/Create",
            Update = "CustomReport/ReportCusPromotionSale/Update",
            Delete = "CustomReport/ReportCusPromotionSale/Delete",
            Retrieve = "CustomReport/ReportCusPromotionSale/Retrieve",
            List = "CustomReport/ReportCusPromotionSale/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportCusPromotionSaleService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
